import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './modules/lps-member-login/components/layout/dashboard/dashboard.component';
import { DashboardViewComponent } from './modules/lps-member-login/components/layout/dashboard-view/dashboard-view.component';
import { PatientTableComponent } from './modules/lps-member-login/components/patient-table/patient-table.component';
import { DashboardMemberComponent } from './modules/lps-member-login/components/layout/dashboard-member/dashboard-member.component';
import { AuthGuard } from './auth/auth.guard';
import { AddMedicalProviderComponent } from './modules/lps-member-login/components/add-medical-provider/add-medical-provider.component';
import { ResetPasswordComponent } from './modules/lps-member-login/components/reset-password/reset-password.component';
import { FileViewerComponent } from './modules/lps-member-login/components/shared/file-viewer/file-viewer.component';
import { AdmindashboardComponent } from './modules/lps-member-login/components/admindashboard/admindashboard.component';
import { AdminProfileComponent } from './modules/lps-member-login/components/admin-profile/admin-profile.component';
import { SuperAdminDashboardComponent } from './modules/lps-member-login/components/super-admin-dashboard/super-admin-dashboard.component';
import { AddAdminsComponent } from './modules/lps-member-login/components/add-admins/add-admins.component';
import { DashboardDistriComponent } from './modules/lps-member-login/components/distributor/dashboard-distri/dashboard-distri.component';
import { AllApplicantsComponent } from './modules/lps-member-login/components/distributor/all-applicants/all-applicants.component';
import { StaticPageComponent } from './modules/lps-member-login/components/static-page/static-page.component';
import { HelpandsupportComponent } from './modules/lps-member-login/components/static/helpandsupport/helpandsupport.component';
import { LinkPagesComponent } from './modules/lps-member-login/components/static/link-pages/link-pages.component';
import { AccessibilityGuidanceComponent } from './modules/lps-member-login/components/static/accessibility-guidance/accessibility-guidance.component';
import { RegularityComponent } from './modules/lps-member-login/components/static/regularity/regularity.component';
import { FeaturesSectionComponent } from './modules/lps-member-login/components/features-section/features-section.component';
import { FloatingHelpWindowComponent } from './modules/lps-member-login/components/static/floating-help-window/floating-help-window.component';
import { MailServerComponent } from './modules/lps-member-login/components/mail-server/mail-server.component';
import { AdminsDashboardComponent } from './modules/lps-member-login/components/admins-dashboard/admins-dashboard.component';
import { OrgsRegistrationComponent } from './modules/lps-member-login/components/super-admin/orgs-registration/orgs-registration.component';
import { OrgsViewComponent } from './modules/lps-member-login/components/super-admin/orgs-view/orgs-view.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: '/login/provider',
    pathMatch: 'full'
  },
  { path: 'viewer', component: FileViewerComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard], // 🔐 Guard applied
    children: [
      { path: '', redirectTo: 'provider', pathMatch: 'full' },
      { path: 'insurer', component: DashboardViewComponent },
      { path: 'provider', component: DashboardMemberComponent },
      { path: 'applicants', component: PatientTableComponent },
      { path: 'configuration', component: AdmindashboardComponent },
      { path: 'superAdmin', component: SuperAdminDashboardComponent },
      { path: "addAdmins", component: AddAdminsComponent },
      { path: 'adminprofile/:id', component: AdminProfileComponent },
      { path: 'distributor', component: DashboardDistriComponent },
      { path: 'admins', component: AdminsDashboardComponent },
      { path: 'distributor/applicants', component: AllApplicantsComponent },
      { path: 'add-organisations', component: OrgsViewComponent}
    ]
  },
  { path: "mailServer", component: MailServerComponent },
  { path: 'memberBased/:id', component: AddMedicalProviderComponent },
  {
    path: 'resetpassword', component: ResetPasswordComponent
  },
  { path: 'home', component: StaticPageComponent },

  // Footer section routes
  { path: 'help-support', component: HelpandsupportComponent },
  { path: 'services', component: FeaturesSectionComponent },
  // { path: 'contact', component: StaticPageComponent },
  { path: 'accessibility', component: FloatingHelpWindowComponent },
  { path: 'regulatory', component: RegularityComponent },
  { path: 'terms', component: LinkPagesComponent },

  { path: 'configuration', component: AdmindashboardComponent },
  { path: 'distributor', component: DashboardDistriComponent },
  {
    path: 'resetpassword/provider', component: ResetPasswordComponent
  },
  { path: 'resetpassword/insurer', component: ResetPasswordComponent },
  { path: 'resetpassword/insurer', component: ResetPasswordComponent },
  { path: 'resetpassword/admininsurer', component: ResetPasswordComponent },
  { path: 'resetpassword/adminprovider', component: ResetPasswordComponent },
  { path: 'adminprofile/:id', component: AdminProfileComponent },
  { path: 'resetpassword/admindistributor', component: ResetPasswordComponent },
  { path: 'resetpassword/distributor', component: ResetPasswordComponent },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/lps-member-login/lps-member-login.module').then(m => m.LpsMemberLoginModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
